import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import Select from "react-select";
import AdSense from 'react-adsense';
import { Cookies } from '../../../../index.js';
import { alert_error, alert_success } from "../../../../AppContext.js";
import { MoonLoader } from "react-spinners";
import { FaArrowUp, FaArrowDown, FaSync } from 'react-icons/fa';
import Table_accounts from "../accounts_table";
import Account_edits from "./account_edits";
import { useParams, useNavigate, Link } from 'react-router-dom';
import { RingLoader, BarLoader } from "react-spinners";
import { Helmet } from "react-helmet";

const Muataikhoan = ({ category_main }) => {
    const navigate = useNavigate();
    const { slug_1, slug_2, slug_3, slug_4 } = useParams();
    const [data_acount, set_data_acount] = useState(null);
    const [item_account, set_item_account] = useState(null);
    const [showedit, setshowedit] = useState(false);
    const [modalCategory, setModalCategory] = useState(category_main);

    useEffect(() => {
        get_lists_data();
    }, []);

    const get_lists_data = () => {
        const myCookieValueok = Cookies.get('apikey');

        axios
            .get('https://hust.media/api/orders/account/sellers/lists.php', {
                params: {
                    category: category_main,
                    apikey: myCookieValueok,
                    accounts_type: slug_4
                },
            })
            .then((response) => set_data_acount(response.data))
            .catch((error) => console.log(error));

    };
    const account_edits = (value, targetCategory = category_main) => {
        set_item_account(value);
        setModalCategory(targetCategory);
        setshowedit(true);
    };

    return (
        <>
            <Helmet>
                <title>Quản lý bán tài khoản hust media</title>
                <meta name="description" content="Quản lý bán tài khoản hust media" />
            </Helmet>
            <Account_edits item_account={item_account}
                showedit={showedit}
                setshowedit={setshowedit}
                category_main={modalCategory}
                get_lists_data={get_lists_data}
            />
            {Array.isArray(data_acount) && data_acount.length === 0 ? (
                <div className="mt-4 text-center text-2xl font-bold text-gray-700">
                    Please add the product first.
                </div>
            ) : data_acount && data_acount.length > 0 ? (
                <Table_accounts
                    data_acount={data_acount}
                    category_main={category_main}
                    account_edits={account_edits}
                />) : <div className="mt-4 flex justify-center items-center">
                <BarLoader size={50} color="#003AA5" />{" "}
            </div>
            }
        </>
    );
};

export default Muataikhoan;
